import React, { useRef } from 'react';

interface CollapseListDrawingSetBodyProps {
    itemBody: (node: any, linkBody: any) => React.ReactNode;
    itemUseRef?: any;
    storeLinkBody?: React.MutableRefObject<any>;
}

export const CollapseListDrawingSetBody = ({
    storeLinkBody,
    itemBody,
    itemUseRef,
}: CollapseListDrawingSetBodyProps) => {
    const linkBodyRef = useRef<any>(null);

    if (storeLinkBody) {
        storeLinkBody.current[itemUseRef.__id] = linkBodyRef;
    }

    return <>{itemBody(itemUseRef, linkBodyRef)}</>;
};
